module.exports = __webpack_public_path__ + "img/eth.2faeaaf2.svg";